export default __webpack_public_path__ + "static/media/click.120f7645.svg";